import type { TConfig } from '@@/interfaces';
import {
  mergeObjectsButOverrideArrays,
  mergeObjectsButConcatArrays,
} from '@@/utils/merge';

/*
 * regionConfigMerge concats `visibleCoverages` arrays unless otherwise specified
 * in a regionalConfig's `overrides` array. It initially combines all coverages,
 * then overrides coverages via the `overridenCoverages` reducer function below.
 */
export default function regionConfigMerge(
  defaultConfig: TConfig,
  newConfig: Partial<TConfig>
) {
  const { overrides = [] } = newConfig.visibleCoverages || {};
  const combinedCoverages: TConfig['visibleCoverages'] = mergeObjectsButConcatArrays(
    defaultConfig.visibleCoverages,
    newConfig.visibleCoverages
  );
  const overriddenCoverages: Partial<
    TConfig['visibleCoverages']
  > = overrides.reduce(
    (acc: Partial<TConfig['visibleCoverages']>, key) => ({
      ...acc,
      [key]: newConfig.visibleCoverages?.[key],
    }),
    {}
  );
  const overrideConfig: Partial<TConfig> = {
    ...newConfig,
    visibleCoverages: {
      ...combinedCoverages,
      ...overriddenCoverages,
    },
  };
  return mergeObjectsButOverrideArrays<TConfig>(defaultConfig, overrideConfig);
}
